import { formatPhoneNumber } from './formatPhoneNumber';
import { EUserCardAvatarType } from '../components/UserCard/UserCardAvatar';
import { ACCOUNT_TYPE_NAME } from '../constants/accountTypeName';
import { DEFAULT_USER_DISPLAY_NAME } from '../constants/defaultUserDisplayName';
import { IUserInChatListSchema } from '../types/userData';

const AGENCY_ACCOUNT_TYPES = [
  'agency',
  'management_company',
  'rent_department',
  'specialist',
  'managementCompany',
  'rentDepartment',
];

export type TFormattedCompanionData = {
  companionId: number | undefined;
  companionName: string | undefined;
  companionIdStr: string | undefined;
  accountTypeName: string;
  imageType: EUserCardAvatarType;
  formatPhone: string | undefined;
  avatarUrl: string | null | undefined;
  profileLink: string | null | undefined;
};

export const formatCompanionData = ({
  name,
  agencyName,
  agentAccountType,
  userId: companionId,
  phones,
  agentAvatarUrl: avatarUrl,
  urlToAgentPublicProfile: profileLink,
}: IUserInChatListSchema): TFormattedCompanionData => {
  return {
    companionId,
    companionName: name || agencyName || undefined,
    companionIdStr: companionId ? `id ${companionId}` : undefined,
    accountTypeName: agentAccountType ? ACCOUNT_TYPE_NAME[agentAccountType] : DEFAULT_USER_DISPLAY_NAME,
    imageType:
      agentAccountType && AGENCY_ACCOUNT_TYPES.includes(agentAccountType)
        ? EUserCardAvatarType.Agent
        : EUserCardAvatarType.User,
    formatPhone: phones?.length ? formatPhoneNumber(phones[0]) : undefined,
    avatarUrl,
    profileLink,
  };
};
